import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ROOT_URL from "../../Utilities/apiconfig";
import ContactMarquee from "../Pages/ContactMarquee";

const HealthPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const navigate = useNavigate();

  const handleKnowMore = () => {
    navigate("/contacts");
  };

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${ROOT_URL}/api/healthpackages`);
        setPackages(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch health packages");
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  if (loading) return <p>Loading health packages...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="py-5" style={{ backgroundColor: "#f8f9fa", overflowX: "hidden" }}>
      <div className="container">
        <>
          <Helmet>
            <title>Health Packages | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore</title>
            <meta name="description" content="Columbiaa Hospital offers affordable preventive health packages and executive wellness checkup packages in Kasturi Nagar, Bangalore. Complete health screening, full body checkup, cardiac care, diabetes screening, and more. Book your health package today." />
            <meta name="keywords" content="health packages, Columbiaa Hospital, preventive health checkup, executive wellness package, full body checkup, health screening, medical checkup, health checkup packages, preventive healthcare, wellness packages, hospital in Kasturi Nagar, hospital in Bangalore, best hospital, multi-speciality hospital, health checkup Bangalore, medical checkup package, cardiac health package, diabetes screening, thyroid test, kidney function test, liver function test, complete blood count, affordable health packages, yearly health checkup, executive health checkup, corporate health packages, family health packages, health packages near me" />
            <meta name="author" content="Columbiaa Hospital" />
            <meta name="robots" content="index, follow" />
            <meta property="og:title" content="Health Packages | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore" />
            <meta property="og:description" content="Discover affordable preventive health and executive wellness packages at Columbiaa Hospital, Kasturi Nagar, Bangalore. Book comprehensive health checkup packages today." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://columbiaahospital.com/health-packages" />
            <meta property="og:site_name" content="Columbiaa Hospital" />
            <meta property="og:locale" content="en_IN" />
            <link rel="canonical" href="https://columbiaahospital.com/health-packages" />
            <script type="application/ld+json">
              {`
                {
                  "@context": "https://schema.org",
                  "@type": "MedicalOrganization",
                  "name": "Columbiaa Hospital",
                  "url": "https://columbiaahospital.com",
                  "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
                  "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "+91-8548979899",
                    "contactType": "appointments",
                    "areaServed": "IN",
                    "availableLanguage": ["English", "Hindi", "Kannada"]
                  },
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                    "addressLocality": "Bengaluru",
                    "addressRegion": "Karnataka",
                    "postalCode": "560043",
                    "addressCountry": "IN"
                  },
                  "sameAs": [
                    "https://www.facebook.com/share/1BFLVsneD2/",
                    "https://x.com/columbiaahosp",
                    "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                    "https://www.instagram.com/columbiaahospital/",
                    "https://www.youtube.com/@columbiaahospital"
                  ]
                }
              `}
            </script>
          </Helmet>

          <div className="text-center mb-5" data-aos="fade-right">
            <h2 style={{ fontSize: "44px", fontWeight: "bold" }}>
              Columbiaa Executive Wellness Packages
            </h2>
            <h6 className="pt-3" style={{ fontSize: "18px", fontWeight: "normal" }}>
              As we age, our bodies undergo natural changes... Reaffirm your vitality
              with us because your best years are always ahead.
            </h6>
          </div>
        </>

        <div className="row">
          {packages.map((packageItem, index) => {
            const isExpanded = expandedIndex === index;
            const allTexts = Array.from({ length: 20 }, (_, i) => packageItem[`text${i + 1}`]).filter(Boolean);
            const visibleTexts = isExpanded ? allTexts : allTexts.slice(0, 3);

            return (
              <div
                key={index}
                className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center"
              >
                <article
                  className="card shadow-sm border shadow p-4"
                  style={{ width: "100%", maxWidth: "350px" }}
                >
                  <h3
                    style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center" }}
                    data-aos="fade-right"
                  >
                    {packageItem.name} <br /> ({packageItem.gender})
                  </h3>

                  <div className="text-center mt-2" data-aos="fade-down-left">
                    {/* <span
                      style={{ textDecoration: "line-through", color: "#999", fontSize: "16px" }}
                    >
                      ₹{packageItem.price}
                    </span> */}
                    {/* <span
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#28a745",
                        marginLeft: "10px",
                      }}
                    >
                      ₹{packageItem.discountPrice}
                    </span> */}
                  </div>

                  <ul
                    className="list-unstyled mt-3"
                    style={{ fontSize: "14px", color: "#555", paddingLeft: "20px" }}
                    data-aos="fade-right"
                  >
                    {visibleTexts.map((text, i) => (
                      <li key={i}>{text}</li>
                    ))}

                    {!isExpanded && allTexts.length > 3 && (
                      <li>
                        <span style={{ color: "#000" }}>. . .   </span>
                        <button
                          onClick={() => setExpandedIndex(index)}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            color: "#007bff",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: "14px",
                          }}
                        >
                          View More
                        </button>
                      </li>
                    )}
                  </ul>

                  <div className="text-center mt-3">
                    <button
                      className="btn btn-success"
                      style={{ borderRadius: "8px", padding: "8px 16px" }}
                      onClick={handleKnowMore}
                    >
                      Know More
                    </button>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
      {/* <ContactMarquee/> */}
    </div>
  );
};

export default HealthPackages;
